import React from 'react';
import RuleForm from './SubComponents/RuleForm';
import PolicyDetails from "./SubComponents/PolicyDetails";
import ClonePolicyApp from "./Functionality/ClonePolicyApp";
import ButtonAction from "../../../../../../../components/buttons/ButtonAction";
import HeadTittle from "../../../../../../../components/HeadTittle";
import {CloneIconOptions} from "../../../../../../../components/buttons/IconButtons";
import DivContainerBody from "../../../../../../../components/DivContainerBody";
import DividerWithText from "../../../../../../../components/DividerWithText";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 */
const ClonePayrollPolicy = () => {
    const {
        t,
        item,
        setItem,
        isGlobal,
        emptyFields,
        isValid,
        isValidCalculationValue,
        isValidCalculationValueText,
        handleClone,
        goBack,
        handleChange,
        updateRuleField
    } = ClonePolicyApp();

    return (
        <>
            <HeadTittle onBack={goBack} name='clone'>
                <ButtonAction
                    id='btn_cpp_clone'
                    name='clone'
                    Icon={CloneIconOptions}
                    className='btn-icon-edit'
                    onClick={handleClone}
                />
            </HeadTittle>
            <DivContainerBody>
                <div className='row mt-5'>
                    <PolicyDetails
                        item={item}
                        setItem={setItem}
                        handleChange={handleChange}
                        emptyFields={emptyFields}
                    />
                </div>
                <div className='row mb-60px'>
                    <DividerWithText title={t('rule')} spacing={'my-4'} />
                    <RuleForm
                        rule={item}
                        updateRuleField={updateRuleField}
                        emptyFields={emptyFields}
                        isGlobal={isGlobal}
                        isValid={isValid}
                        isValidCalculationValue={isValidCalculationValue}
                        isValidCalculationValueText={isValidCalculationValueText}
                    />
                </div>
            </DivContainerBody>
        </>
    );
};

export default ClonePayrollPolicy;
